var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralHeatingCoolingCoil = function SvgDAhuGeneralHeatingCoolingCoil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "452,460 440,448 440,376 442,376 442,360 450,360 450,376 452,376",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 360,
    width: 1,
    height: 91,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 360,
    width: 2,
    height: 93,
    fill: "#DF1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450,458 449,458 449,360 450,360",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "440,448 452,460 414,460 414,448",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 457,
    width: 36,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 453,
    width: 33,
    height: 2,
    fill: "#DF1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443,450 443,451 414,451 414,450",
    fill: "#787878"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "476,460 488,448 488,376 486,376 486,360 478,360 478,376 476,376",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485,
    y: 360,
    width: 1,
    height: 91,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481,
    y: 360,
    width: 2,
    height: 93,
    fill: "#437FA3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478,458 479,458 479,360 478,360",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "488,448 476,460 514,460 514,448",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478,
    y: 457,
    width: 36,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481,
    y: 453,
    width: 33,
    height: 2,
    fill: "#437FA3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485,450 485,451 514,451 514,450",
    fill: "#787878"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 466,
    y: 300,
    width: 32,
    height: 60,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,301v58h-30v-58H497 M498,300h-32v60h32V300L498,300z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 449.3,
    y: 329.5,
    transform: "matrix(0.469 -0.8832 0.8832 0.469 -35.5287 600.9531)",
    width: 65.3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.5,
    y: 297.4,
    transform: "matrix(0.8836 -0.4682 0.4682 0.8836 -98.4286 264.103)",
    width: 1,
    height: 65.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M486,308.3h-8v-1.6h8V308.3z",
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 300,
    width: 32,
    height: 60,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,301v58h-30v-58H461 M462,300h-32v60h32V300L462,300z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 413.3,
    y: 329.5,
    transform: "matrix(0.469 -0.8832 0.8832 0.469 -54.6511 569.157)",
    width: 65.3,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.5,307 438.4,307 438.4,303.8 436.8,303.8 436.8,307 433.5,307 433.5,308.5 436.8,308.5 436.8,311.8 438.4,311.8 438.4,308.5 441.5,308.5",
    fill: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 446,
    y1: 408,
    x2: 446,
    y2: 380,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 393,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "446,395 453.1,407.5 438.9,407.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,396l6.3,11h-12.5L446,396 M446,394l-8,14h16L446,394L446,394L446,394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "438.9,380.5 453.1,380.5 446,393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.3,381l-6.3,11l-6.3-11H452.3 M454,380h-16l8,14L454,380L454,380L454,380z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 394,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,384c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S419.5,384,425,384 M425,383c-6.1,0-11,4.9-11,11s4.9,11,11,11 s11-4.9,11-11S431.1,383,425,383L425,383z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M427.4,391.1v5.7h-1V395l0.1-2.5l-1.7,4.4h-0.7l-1.7-4.4l0.1,2.5v1.9h-1v-5.7h1.3l1.6,4.4l1.6-4.4H427.4L427.4,391.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 421,
    width: 5.5,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 446,
    cy: 394,
    r: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,390c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S443.8,390,446,390 M446,389c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5 S448.8,389,446,389L446,389z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 438.5,
    y: 408.5,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,409v2h-14v-2H453 M454,408h-16v4h16V408L454,408z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 438.5,
    y: 432.5,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,433v2h-14v-2H453 M454,432h-16v4h16V432L454,432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 411.5,
    width: 9,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,412v20h-8v-20H450 M451,411h-10v22h10V411L451,411z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M441.9,432.2l-0.8-0.6c1.7-2.5,2.8-6.1,2.8-9.6s-1-7.1-2.8-9.6l0.8-0.6c1.8,2.7,2.9,6.5,2.9,10.2 S443.7,429.5,441.9,432.2L441.9,432.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.1,432.2c-1.8-2.7-2.9-6.5-2.9-10.1s1.1-7.5,2.9-10.2l0.8,0.6c-1.7,2.5-2.8,6.2-2.8,9.6s1,7,2.8,9.6L450.1,432.2 L450.1,432.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 411,
    width: 22,
    height: 22,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,412v20h-20v-20H435 M436,411h-22v22h22V411L436,411z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425,423.4l1.4-4.4h1.1l-2,5.7h-1l-2-5.7h1.1L425,423.4L425,423.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 407.4,
    transform: "matrix(3.839736e-03 -1 1 3.839736e-03 15.4004 831.3591)",
    width: 6,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 482,
    y1: 408,
    x2: 482,
    y2: 380,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 393,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "474.9,407.5 482,395 489.1,407.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,396l6.3,11h-12.5L482,396 M482,394l-8,14h16L482,394L482,394L482,394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "474.9,380.5 489.1,380.5 482,393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.7,381h12.5l-6.3,11L475.7,381 M474,380l8,14l8-14L474,380L474,380z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 503,
    cy: 394,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503,384c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S497.5,384,503,384 M503,383c-6.1,0-11,4.9-11,11s4.9,11,11,11 s11-4.9,11-11S509.1,383,503,383L503,383z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M501.9,391.1l1.6,4.4l1.6-4.4h1.3v5.7h-1V395l0.1-2.5l-1.7,4.4h-0.7l-1.7-4.4l0.1,2.5v1.9h-1v-5.7H501.9L501.9,391.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 486.5,
    y: 421,
    width: 5.5,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 394,
    r: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,390c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S479.8,390,482,390 M482,389c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5 S484.8,389,482,389L482,389z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 474.5,
    y: 408.5,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,409v2h-14v-2H489 M490,408h-16v4h16V408L490,408z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 474.5,
    y: 432.5,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,433v2h-14v-2H489 M490,432h-16v4h16V432L490,432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 477.5,
    y: 411.5,
    width: 9,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486,412v20h-8v-20H486 M487,411h-10v22h10V411L487,411z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M486.1,432.2c-1.8-2.7-2.9-6.5-2.9-10.1s1.1-7.5,2.9-10.2l0.8,0.6c-1.7,2.5-2.8,6.2-2.8,9.6s1,7,2.8,9.6L486.1,432.2 L486.1,432.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.9,432.2l-0.8-0.6c1.7-2.5,2.8-6.1,2.8-9.6s-1-7.1-2.8-9.6l0.8-0.6c1.8,2.7,2.9,6.5,2.9,10.2 S479.7,429.5,477.9,432.2L477.9,432.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 411,
    width: 22,
    height: 22,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513,412v20h-20v-20H513 M514,411h-22v22h22V411L514,411z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M504.4,419h1.1l-2,5.7h-1l-2-5.7h1.1l1.4,4.4L504.4,419L504.4,419z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.5,
    y: 405,
    transform: "matrix(1 -3.141572e-03 3.141572e-03 1 -1.2792 1.5823)",
    width: 1,
    height: 6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "420,433 418.5,438.4 419.5,438.4 419.5,443 420.5,443 420.5,438.4 421.5,438.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430,433 428.5,438.4 429.5,438.4 429.5,443 430.5,443 430.5,438.4 431.5,438.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "509.5,438.4 508,433 506.5,438.4 507.5,438.4 507.5,443 508.5,443 508.5,438.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "498,433 496.5,438.4 497.5,438.4 497.5,443 498.5,443 498.5,438.4 499.5,438.4"
  }))))));
};
export default SvgDAhuGeneralHeatingCoolingCoil;